module.exports = __webpack_public_path__ + "images/store_case_study/brandvalue-pic2_3aa299b7a02ea1a8057d97cde15b8dca.png";